import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import SoftCard from '../SoftCard/SoftCard';
import ASoftCard from '../ASoftCard/ASoftCard';
import CardIndex from '../../card/CardIndex/CardIndex';
import { getRecommendGroup, getGuessLikes } from '../../actions/recommend';
import { sortSoftsByLocalSoftInit } from '../../utils/utils';
import styles from './CommReco.module.less';

const selectGroups = createSelector(
  state => state.recommend,
  recommend => recommend.commGroups,
);

const selectGuessLikes = createSelector(
  state => state.recommend,
  recommend => recommend.guessLike,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const pageSize = 60;
const showSize = 24;
export default memo(({ logInfo }) => {
  const dispatch = useDispatch();
  const groupsData = useSelector(selectGroups);
  const guessLikesData = useSelector(selectGuessLikes);
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const [showGuessLikes, setShowGuessLikes] = useState([]);

  useEffect(() => {
    if (
      !(
        groupsData &&
        groupsData.dataList &&
        groupsData.dataList.length > 0 &&
        groupsData.pageType === 'upgrade' &&
        groupsData.tag === logInfo.tag
      )
    ) {
      dispatch(getRecommendGroup({ pageType: 'upgrade', tag: logInfo.tag }));
    }
  }, []);

  useEffect(() => {
    if (!guessLikesData || !guessLikesData.apps || guessLikesData.limit !== pageSize) {
      dispatch(getGuessLikes({ skip: 0, limit: pageSize }));
    } else {
      const show_Apps = sortSoftsByLocalSoftInit(guessLikesData.apps || [], localSoftsInit);
      setShowGuessLikes(show_Apps.slice(0, showSize));
    }
  }, [dispatch, guessLikesData, localSoftsInit]);

  return (
    <div className={styles.comm}>
      <div className={styles.comm_groups}>
        {/* group */}
        {groupsData &&
          groupsData.dataList &&
          groupsData.dataList.length > 0 &&
          groupsData.pageType === 'upgrade' &&
          groupsData.dataList.map((item, i) => (
            <CardIndex data={item} key={i} logInfo={{ tag: logInfo.tag }} />
          ))}
      </div>

      {showGuessLikes && showGuessLikes.length > 0 && (
        <div className={styles.comm_guess}>
          <div className={styles.comm_guess_header}>
            <div className={styles.comm_guess_header_title}>试试这些有用的软件吧</div>
            {/* <Link
              className={styles.comm_guess_header_link}
              onClick={() => {
                handleShowMore();
              }}
              to={{ pathname: `${CONTEXT}/guesslikesmore` }}
            >
              查看更多
            </Link> */}
          </div>
          <div className={styles.comm_guess_cards}>
            {showGuessLikes.slice(0, 9).map((soft, j) =>
              soft.androidType === '1' ? (
                <ASoftCard
                  soft={{ ...soft, cardShowDesc: true }}
                  logInfo={{
                    source: `${logInfo.tag}_Try`,
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                  }}
                  key={j}
                />
              ) : (
                <SoftCard
                  soft={{ ...soft, cardShowDesc: true }}
                  logInfo={{
                    source: `${logInfo.tag}_Try`,
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                  }}
                  key={j}
                />
              ),
            )}
          </div>
        </div>
      )}
    </div>
  );
});
